import React from 'react';

function Footer() {
  const currentYear = new Date().getFullYear();
  
  return (
    <div id="footer">
      <div className="container">
        <p>
          © {currentYear} Moieo
        </p>
        <p style={{ marginTop: '8px', fontSize: '12px', opacity: '0.8' }}>
          <i className="fas fa-sync-alt"></i> 数据每 15 分钟更新一次
        </p>
      </div>
    </div>
  );
}

export default Footer;